// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3KbKp","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3ibmC"};